export default class Constants {
  static REQUIRED_LOGIN = 'REQUIRED_LOGIN';
  static MAX_VALUE_STAKE = 999999999;
  static WAGER_TYPE = {
     NORMAL: 'NORMAL',
     OUTRIGHT: 'OUTRIGHT',
     PARLAY: 'PARLAY',
     TEASERS: 'TEASERS'
  }
  static WAGER_STATUS = {
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    SETTLED: 'SETTLED', 
    CANCELLED: 'CANCELLED',
    DELETED: 'DELETED',
    ACCEPTED: 'ACCEPTED',
    REFUNDED: 'REFUNDED',
    RESETTLED: 'RESETTLED',
    WIN: 'WIN',
    LOSS: 'LOSS',
    DRAW: 'DRAW',
    RUNNING: 'RUNNING',
    REJECTED: 'REJECTED',
    SUCCESS: 'SUCCESS'
  }

  static ESPORT_ALL_GAMES_ID = -2;

  static ASIA_BETSLIP_TYPES = {
    SINGLE: 'single',
    PARLAY: 'parlay',
    OUTRIGHT: 'outright',
    TEASER: 'teaser'
  }

  static LEFT_HEADER_PATH = {
    SPORTS: 'sports',
    ESPORTS: 'esports',
    ESPORTS_HUB: 'esports-hub',
    INPLAY: 'inplay',
    CASINO: 'casino',
    LIVE_CASINO: 'live-casino',
    KY_GAMING: 'chess-and-cards',
    PARLAY: 'Mix Parlay'
  }

  static ACTION_RIGHT_MENU = {
    Messages: "Messages",
    Profile: "Profile",
    Balance: "Balance",
    MyBets: "MyBets",
    Statements: "Statements",
    Settings: "Settings",
    Results: "Results",
    Promotions: "Promotions",
    Announcements: "Announcements",
    Banking: "Banking",
    NGC: "NGC",
    LogOut: "LogOut",
    BettingRules: "BettingRules"
  }

  static OUTRIGHT_ID = 100;

  static NOSPORT_ID = 0;

  static SOCCER_ID = 29;

  static HOCKEY_ID = 19;

  static DEFAULT_ITEM_IN_ROW = 3;

  static LEFT_MENU_PANEL_HEADER = {
    DEFAULT_ITEM_IN_ROW: 3,
    CUSTOM_ITEM_IN_ROW: 2,
    COL_CLASS_DEFAULT_ITEM_IN_ROW: 4,
    COL_CLASS_CUSTOM_ITEM_IN_ROW: 6
  }
  
  static SUPPORT_PARLAY = {
    ALLOWED_WITHOUT_RESTRICTIONS: 0, // 0 = Allowed to parlay, without restrictions
    NOT_ALLOWED: 1, // 1 = Not allowed to parlay this event
    ALLOWED_WITH_RESTRICTIONS: 2 //  2 = Allowed to parlay with the restrictions
  }
  
  static INPLAY_EVENT = {
    RUNNING: 1,
    NOT_RUNNING: 0
  }

  static WIN_RISK_OPTION = {
    WIN: 'WIN',
    RISK: 'RISK',
    BASE: 'BASE'
  }
  static TOAST_TIMEOUT=5000
  static TOAST = {
    TOAST_CLASS_ACTIVE: 'active',
    TOAST_CLASS_WARNING: 'warning',
    TOAST_CLASS_ERROR: 'error',
    ADDING_BET_MESSAGE: 'Your bet was added to Bet Slip',
    EXISTING_BET_MESSAGE: 'This bet already exists on your Bet Slip',
    ERROR_MESSAGES: 'INTERNAL_ERROR',
    MAXIMUM_BET_MESSAGE: 'You have added the maximum number of bets',
    PROCESSING_BET_MESSAGE: 'Processing Bet',
    ACCEPTED_BET_MESSAGE: 'Your bet was Accepted',
    UNACCEPTED_BET_MESSAGE: 'Your bet was Unaccepted',
    MAX_TEASERS: 'MaxTeasers',
    NEW_TOAST_CLASS_ACTIVE: 'active new-toast',
    NEW_TOAST_CLASS_WARNING: 'warning new-toast',
    NEW_TOAST_CLASS_ERROR: 'error new-toast',
    NEW_ACCEPTED_BET_MESSAGE: 'Your bet was accepted.',
    NEW_UNACCEPTED_BET_MESSAGE: 'Your bet was not accepted.',
    NEW_PROCESSING_BET_MESSAGE: 'Your bets are being processed...',
    VERIFIED_SUCCESSFULLY_CLASS: 'verified-successfully',
  }
  static OUTRIGHT = 'Outright';
  static MIX_PARLAY = 'MixParlay';
  static TEASERS = 'Teasers';
  static CORRECT_SCORE = 'CorrectScore';
  static DOUBLE_CHANCE = 'DoubleChance';

  static BETSLIP_TAB = {
    SINGLE: 'single',
    PARLAY: 'parlay',
    TEASERS: 'teasers',
    NONE: ''
  }

  static TEMPLATE_TYPE = {
    WHITELABEL: 'whitelabel',
    IFRAME: 'iFrame',
  }
  static SUPPORT_PRODUCT_ONLY = {
    ALL: 'All',
    SPORTS: 'sport',
    ESPORTS: 'esport'
  }
  

  static TEASER_ERROR = {
    TOO_MANY_LEGS: 'TOO_MANY_LEGS',
    TOO_FEW_LEGS: 'TOO_FEW_LEGS',
    POINTS_NO_LONGER_AVAILABLE: 'POINTS_NO_LONGER_AVAILABLE',
    EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
    OFFLINE_EVENT: 'OFFLINE_EVENT',
    INVALID_EVENT: 'INVALID_EVENT',
    LINE_CHANGED: 'LINE_CHANGED',
    BET_LINE_CHANGED: 'BET_LINE_CHANGED',
    LINE_IS_NOT_AVAILABLE: 'LINE_IS_NOT_AVAILABLE',
    BET_LINE_IS_NOT_AVAILABLE: 'BET_LINE_IS_NOT_AVAILABLE',
    POINT_CHANGE: 'POINT_CHANGE',
    SELECTION_POINT_CHANGED: 'SELECTION_POINT_CHANGED',
    SELECTION_UNAVALABLE: 'SELECTION_UNAVALABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    INVALID_LEGS: 'INVALID_LEGS',
  }

  static EURO_VIEW_SIDEBAR_WITHD = 260;

  static ASIA_VIEW_SIDEBAR_WIDTH_LEFT = 321;
  static MAX_SELECTION_LENGHT = 10
  static MID_ASIA_VIEW_SIDEBAR_WIDTH_LEFT = 300;
  static SMALL_ASIA_VIEW_SIDEBAR_WIDTH_LEFT = 265;
  static ASIA_VIEW_SIDEBAR_WIDTH_RIGHT = 265;
  static ESPORT_ID = 12;
  static FOOTBALL_ID = 15;
  static BASEBALL_ID = 3;
  static BASKETBALL_ID = 4;
  static TENNIS_ID = 33;
  static ONWARDS = "Onwards";
  static UNAVAILABLE_MESSAGE = 'Current selection is unavailable for betting.';
  static UNAVAILABLE = 'UNAVAILABLE';
  static INVALID_BET_ACCEPTANCE_TYPE = 'INVALID_BET_ACCEPTANCE_TYPE';
  static ODDS_CHANGE = 'ODDS_CHANGE';
  static ODDS_CHANGED_MESSAGE = 'ODDS_CHANGED_MESSAGE'
  static LINE_CHANGED = 'LINE_CHANGED';
  static OFFLINE_EVENT = 'OFFLINE_EVENT';
  static INVALID_EVENT = 'INVALID_EVENT';
  static BET_OFFLINE_EVENT = 'BET_OFFLINE_EVENT';
  static EVENT_NOT_FOUND = 'EVENT_NOT_FOUND';
  static BET_LINE_CHANGED = 'BET_LINE_CHANGED';
  static CORRELATED = 'CORRELATED';
  static BLOCKED_AGE_GROUP = 'BLOCKED_AGE_GROUP';
  static BLOCKED_PARLAY_BET = 'BLOCKED_PARLAY_BET';
  static SELECTION_UNAVAILABLE = 'Selection is currently unavailable.'
  static EVENT_NOT_OFFERED_FOR_PARLAY = 'EVENT_NOT_OFFERED_FOR_PARLAY';
  static LINE_IS_NOT_AVAILABLE = 'LINE_IS_NOT_AVAILABLE';
  static VALID = 'VALID';
  static ACCEPTED = 'ACCEPTED';
  static EVENT_OFFLINE = 'ERROR3105'
  static MAX_BET_EXCEEDED = 'MAX_BET_EXCEEDED';
  static PENDING_ACCEPTANCE = 'PENDING_ACCEPTANCE';
  static PROCESSED_WITH_ERROR = 'PROCESSED_WITH_ERROR';
  static ABOVE_MAX_BET_AMOUNT = 'ABOVE_MAX_BET_AMOUNT';
  static BELOW_MIN_BET_AMOUNT = 'BELOW_MIN_BET_AMOUNT';
  static RESPONSIBLE_LIMIT_EXCEEDED_RISK = 'RESPONSIBLE_LIMIT_EXCEEDED_RISK';
  static RESPONSIBLE_LIMIT_EXCEEDED_LOSS = 'RESPONSIBLE_LIMIT_EXCEEDED_LOSS';
  static INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS';
  static INSUFFICIENT_BONUS_FUNDS = 'INSUFFICIENT_BONUS_FUNDS';
  static ODDS_CHANGE_TO = 'Odds has been changed to';
  static BETSLIP_SIZE_MESSAGE = 'Maximum is 10 selections.';
  static BETS_CONFIRMATION = 'BETS_CONFIRMATION';
  static VALIDATED_OK = 'OK';
  static VALIDATED_ERROR = 'ERROR';
  static MAX_ZERO_MESSAGE = 'MAX_ZERO_MESSAGE';
  static INVALID_MIN_STAKE = 'INVALID_MIN_STAKE';
  static INVALID_MAX_STAKE = 'INVALID_MAX_STAKE';
  static INVALID_MAX_MIN_STAKE = 'INVALID_MAX_MIN_STAKE';
  static INVALID_STAKE = 'INVALID_STAKE';
  static MAXIMUM_AMOUNT = 'MAXIMUM_AMOUNT';
  static MINIMUM_AMOUNT = 'MINIMUM_AMOUNT';
  static PLACE_BET_ERROR = {
    E999 : 'E999'
  }
  static LANDING_PAGE_URL = '/en/asian';
  static DEFAULT_SPORT_NAME = 'Soccer';
  static BETSLIP = {
    SINGLE_CORRELATED_MESSAGE: {
      TITLE: 'SINGLE_CORRELATED_TITLE',
    },
  };
  static HEADER = {};
  static LEFT_MENU = {};
  static RIGHT_MENU = {};
  static FOOTER = {};
  static TIMEZONE_REG_EXP_FORMAT = "\\(GMT(.*?)\\)";
  static TIMEZONES = [
    ["Afghanistan Standard Time", "Asia/Kabul", "(GMT +04:30) Kabul"],
    ["Alaskan Standard Time", "America/Anchorage", "(GMT -09:00) Alaska"],
    ["Arab Standard Time", "Asia/Riyadh", "(GMT +03:00) Kuwait, Riyadh"],
    ["Arabian Standard Time", "Asia/Dubai", "(GMT +04:00) Abu Dhabi, Muscat"],
    ["Arabic Standard Time", "Asia/Baghdad", "(GMT +03:00) Baghdad"],
    ["Argentina Standard Time", "America/Buenos_Aires", "(GMT -03:00) Buenos Aires"],
    ["Atlantic Standard Time", "America/Halifax", "(GMT -04:00) Atlantic Time (Canada)"],
    ["AUS Central Standard Time", "Australia/Darwin", "(GMT +09:30) Darwin"],
    ["AUS Eastern Standard Time", "Australia/Sydney", "(GMT +10:00) Canberra, Melbourne, Sydney"],
    ["Azerbaijan Standard Time", "Asia/Baku", "(GMT +04:00) Baku"],
    ["Azores Standard Time", "Atlantic/Azores", "(GMT -01:00) Azores"],
    ["Bangladesh Standard Time", "Asia/Dhaka", "(GMT +06:00) Dhaka"],
    ["Canada Central Standard Time", "America/Regina", "(GMT -06:00) Saskatchewan"],
    ["Cape Verde Standard Time", "Atlantic/Cape_Verde", "(GMT -01:00) Cape Verde Is."],
    ["Caucasus Standard Time", "Asia/Yerevan", "(GMT +04:00) Yerevan"],
    ["Cen. Australia Standard Time", "Australia/Adelaide", "(GMT +09:30) Adelaide"],
    ["Central America Standard Time", "America/Guatemala", "(GMT -06:00) Central America"],
    ["Central Asia Standard Time", "Asia/Almaty", "(GMT +06:00) Astana"],
    ["Central Brazilian Standard Time", "America/Cuiaba", "(GMT -04:00) Cuiaba"],
    ["Central Europe Standard Time", "Europe/Budapest", "(GMT +01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"],
    ["Central European Standard Time", "Europe/Warsaw", "(GMT +01:00) Sarajevo, Skopje, Warsaw, Zagreb"],
    ["Central Pacific Standard Time", "Pacific/Guadalcanal", "(GMT +11:00) Solomon Is., New Caledonia"],
    ["Central Standard Time (Mexico)", "America/Mexico_City", "(GMT -06:00) Guadalajara, Mexico City, Monterrey"],
    ["Central Standard Time", "America/Chicago", "(GMT -06:00) Central Time (US & Canada)"],
    ["China Standard Time", "Asia/Shanghai", "(GMT +08:00) Beijing, Chongqing, Hong Kong, Urumqi"],
    ["Dateline Standard Time", "Etc/GMT+12", "(GMT -12:00) International Date Line West"],
    ["E. Africa Standard Time", "Africa/Nairobi", "(GMT +03:00) Nairobi"],
    ["E. Australia Standard Time", "Australia/Brisbane", "(GMT +10:00) Brisbane"],
    ["E. Europe Standard Time", "Europe/Minsk", "(GMT +02:00) Minsk"],
    ["E. South America Standard Time", "America/Sao_Paulo", "(GMT -03:00) Brasilia"],
    ["Eastern Standard Time", "America/New_York", "(GMT -05:00) Eastern Time (US & Canada)"],
    ["Egypt Standard Time", "Africa/Cairo", "(GMT +02:00) Cairo"],
    ["Ekaterinburg Standard Time", "Asia/Yekaterinburg", "(GMT +05:00) Ekaterinburg"],
    ["Fiji Standard Time", "Pacific/Fiji", "(GMT +12:00) Fiji, Marshall Is."],
    ["FLE Standard Time", "Europe/Kiev", "(GMT +02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"],
    ["Georgian Standard Time", "Asia/Tbilisi", "(GMT +04:00) Tbilisi"],
    ["GMT Standard Time", "Europe/London", "(GMT) Dublin, Edinburgh, Lisbon, London"],
    ["Greenland Standard Time", "America/Godthab", "(GMT -03:00) Greenland"],
    ["Greenwich Standard Time", "Atlantic/Reykjavik", "(GMT) Monrovia, Reykjavik"],
    ["GTB Standard Time", "Europe/Istanbul", "(GMT +02:00) Athens, Bucharest, Istanbul"],
    ["Hawaiian Standard Time", "Pacific/Honolulu", "(GMT -10:00) Hawaii"],
    ["India Standard Time", "Asia/Calcutta", "(GMT +05:30) Chennai, Kolkata, Mumbai, New Delhi"],
    ["Iran Standard Time", "Asia/Tehran", "(GMT +03:30) Tehran"],
    ["Israel Standard Time", "Asia/Jerusalem", "(GMT +02:00) Jerusalem"],
    ["Jordan Standard Time", "Asia/Amman", "(GMT +02:00) Amman"],
    ["Kamchatka Standard Time", "Asia/Kamchatka", "(GMT +12:00) Petropavlovsk-Kamchatsky - Old"],
    ["Korea Standard Time", "Asia/Seoul", "(GMT +09:00) Seoul"],
    ["Magadan Standard Time", "Asia/Magadan", "(GMT +11:00) Magadan"],
    ["Mauritius Standard Time", "Indian/Mauritius", "(GMT +04:00) Port Louis"],
    ["Mid-Atlantic Standard Time", "America/Noronha", "(GMT -02:00) Mid-Atlantic"],
    ["Middle East Standard Time", "Asia/Beirut", "(GMT +02:00) Beirut"],
    ["Montevideo Standard Time", "America/Montevideo", "(GMT -03:00) Montevideo"],
    ["Morocco Standard Time", "Africa/Casablanca", "(GMT) Casablanca"],
    ["Mountain Standard Time (Mexico)", "America/Chihuahua", "(GMT -07:00) Chihuahua, La Paz, Mazatlan"],
    ["Mountain Standard Time", "America/Denver", "(GMT -07:00) Mountain Time (US & Canada)"],
    ["Myanmar Standard Time", "Asia/Rangoon", "(GMT +06:30) Yangon (Rangoon)"],
    ["N. Central Asia Standard Time", "Asia/Novosibirsk", "(GMT +06:00) Novosibirsk"],
    ["Namibia Standard Time", "Africa/Windhoek", "(GMT +02:00) Windhoek"],
    ["Nepal Standard Time", "Asia/Katmandu", "(GMT +05:45) Kathmandu"],
    ["New Zealand Standard Time", "Pacific/Auckland", "(GMT +12:00) Auckland, Wellington"],
    ["Newfoundland Standard Time", "America/St_Johns", "(GMT -03:30) Newfoundland"],
    ["North Asia East Standard Time", "Asia/Irkutsk", "(GMT +08:00) Irkutsk"],
    ["North Asia Standard Time", "Asia/Krasnoyarsk", "(GMT +07:00) Krasnoyarsk"],
    ["Pacific SA Standard Time", "America/Santiago", "(GMT -04:00) Santiago"],
    ["Pacific Standard Time (Mexico)", "America/Tijuana", "(GMT -08:00) Baja California"],
    ["Pacific Standard Time", "America/Los_Angeles", "(GMT -08:00) Pacific Time (US & Canada)"],
    ["Pakistan Standard Time", "Asia/Karachi", "(GMT +05:00) Islamabad, Karachi"],
    ["Paraguay Standard Time", "America/Asuncion", "(GMT -04:00) Asuncion"],
    ["Romance Standard Time", "Europe/Paris", "(GMT +01:00) Brussels, Copenhagen, Madrid, Paris"],
    ["Russian Standard Time", "Europe/Moscow", "(GMT +03:00) Moscow, St. Petersburg, Volgograd"],
    ["SA Eastern Standard Time", "America/Cayenne", "(GMT -03:00) Cayenne, Fortaleza"],
    ["SA Pacific Standard Time", "America/Bogota", "(GMT -05:00) Bogota, Lima, Quito"],
    ["SA Western Standard Time", "America/La_Paz", "(GMT -04:00) Georgetown, La Paz, Manaus, San Juan"],
    ["Samoa Standard Time", "Pacific/Apia", "(GMT -11:00) Samoa"],
    ["SE Asia Standard Time", "Asia/Bangkok", "(GMT +07:00) Bangkok, Hanoi, Jakarta"],
    ["Singapore Standard Time", "Asia/Singapore", "(GMT +08:00) Kuala Lumpur, Singapore"],
    ["South Africa Standard Time", "Africa/Johannesburg", "(GMT +02:00) Harare, Pretoria"],
    ["Sri Lanka Standard Time", "Asia/Colombo", "(GMT +05:30) Sri Jayawardenepura"],
    ["Syria Standard Time", "Asia/Damascus", "(GMT +02:00) Damascus"],
    ["Taipei Standard Time", "Asia/Taipei", "(GMT +08:00) Taipei"],
    ["Tasmania Standard Time", "Australia/Hobart", "(GMT +10:00) Hobart"],
    ["Tokyo Standard Time", "Asia/Tokyo", "(GMT +09:00) Osaka, Sapporo, Tokyo"],
    ["Tonga Standard Time", "Pacific/Tongatapu", "(GMT +13:00) Nuku'alofa"],
    ["Ulaanbaatar Standard Time", "Asia/Ulaanbaatar", "(GMT +08:00) Ulaanbaatar"],
    ["US Eastern Standard Time", "America/Indianapolis", "(GMT -05:00) Indiana (East)"],
    ["US Mountain Standard Time", "America/Phoenix", "(GMT -07:00) Arizona"],
    ["GMT ", "Etc/GMT", "(GMT) Coordinated Universal Time"],
    ["GMT +12", "Etc/GMT-12", "(GMT +12:00) Coordinated Universal Time+12"],
    ["GMT -02", "Etc/GMT+2", "(GMT -02:00) Coordinated Universal Time-02"],
    ["GMT -11", "Etc/GMT+11", "(GMT -11:00) Coordinated Universal Time-11"],
    ["Venezuela Standard Time", "America/Caracas", "(GMT -04:30) Caracas"],
    ["Vladivostok Standard Time", "Asia/Vladivostok", "(GMT +10:00) Vladivostok"],
    ["W. Australia Standard Time", "Australia/Perth", "(GMT +08:00) Perth"],
    ["W. Central Africa Standard Time", "Africa/Lagos", "(GMT +01:00) West Central Africa"],
    ["W. Europe Standard Time", "Europe/Berlin", "(GMT +01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"],
    ["West Asia Standard Time", "Asia/Tashkent", "(GMT +05:00) Tashkent"],
    ["West Pacific Standard Time", "Pacific/Port_Moresby", "(GMT +10:00) Guam, Port Moresby"],
    ["Yakutsk Standard Time", "Asia/Yakutsk", "(GMT +09:00) Yakutsk"],
  ];
  static COUNTRY_CODES = [
    {"name": "Afghanistan", "phone-code": "+93", "country-code": "AF"},
    {"name": "Albania", "phone-code": "+355", "country-code": "AL"},
    {"name": "Algeria", "phone-code": "+213", "country-code": "DZ"},
    {"name": "American Samoa", "phone-code": "+1-684", "country-code": "AS"},
    {"name": "Andorra", "phone-code": "+376", "country-code": "AD"},
    {"name": "Angola", "phone-code": "+244", "country-code": "AO"},
    {"name": "Anguilla", "phone-code": "+1-264", "country-code": "AI"},
    {"name": "Antarctica", "phone-code": "+672", "country-code": "AQ"},
    {"name": "Antigua and Barbuda", "phone-code": "+1-268", "country-code": "AG"},
    {"name": "Argentina", "phone-code": "+54", "country-code": "AR"},
    {"name": "Armenia", "phone-code": "+374", "country-code": "AM"},
    {"name": "Aruba", "phone-code": "+297", "country-code": "AW"},
    {"name": "Australia", "phone-code": "+61", "country-code": "AU"},
    {"name": "Austria", "phone-code": "+43", "country-code": "AT"},
    {"name": "Azerbaijan", "phone-code": "+994", "country-code": "AZ"},
    {"name": "Bahamas", "phone-code": "+1-242", "country-code": "BS"},
    {"name": "Bahrain", "phone-code": "+973", "country-code": "BH"},
    {"name": "Bangladesh", "phone-code": "+880", "country-code": "BD"},
    {"name": "Barbados", "phone-code": "+1-246", "country-code": "BB"},
    {"name": "Belarus", "phone-code": "+375", "country-code": "BY"},
    {"name": "Belgium", "phone-code": "+32", "country-code": "BE"},
    {"name": "Belize", "phone-code": "+501", "country-code": "BZ"},
    {"name": "Benin", "phone-code": "+229", "country-code": "BJ"},
    {"name": "Bermuda", "phone-code": "+1-441", "country-code": "BM"},
    {"name": "Bhutan", "phone-code": "+975", "country-code": "BT"},
    {"name": "Bolivia", "phone-code": "+591", "country-code": "BO"},
    {"name": "Bosnia and Herzegovina", "phone-code": "+387", "country-code": "BA"},
    {"name": "Botswana", "phone-code": "+267", "country-code": "BW"},
    {"name": "Brazil", "phone-code": "+55", "country-code": "BR"},
    {"name": "British Indian Ocean Territory", "phone-code": "+246", "country-code": "IO"},
    {"name": "British Virgin Islands", "phone-code": "+1-284", "country-code": "VG"},
    {"name": "Brunei", "phone-code": "+673", "country-code": "BN"},
    {"name": "Bulgaria", "phone-code": "+359", "country-code": "BG"},
    {"name": "Burkina Faso", "phone-code": "+226", "country-code": "BF"},
    {"name": "Burundi", "phone-code": "+257", "country-code": "BI"},
    {"name": "Cambodia", "phone-code": "+855", "country-code": "KH"},
    {"name": "Cameroon", "phone-code": "+237", "country-code": "CM"},
    {"name": "Canada", "phone-code": "+1", "country-code": "CA"},
    {"name": "Cape Verde", "phone-code": "+238", "country-code": "CV"},
    {"name": "Cayman Islands", "phone-code": "+1-345", "country-code": "KY"},
    {"name": "Central African Republic", "phone-code": "+236", "country-code": "CF"},
    {"name": "Chad", "phone-code": "+235", "country-code": "TD"},
    {"name": "Chile", "phone-code": "+56", "country-code": "CL"},
    {"name": "China", "phone-code": "+86", "country-code": "CN"},
    {"name": "Christmas Island", "phone-code": "+6189164", "country-code": "CX"},
    {"name": "Cocos Islands", "phone-code": "+6189162", "country-code": "CC"},
    {"name": "Colombia", "phone-code": "+57", "country-code": "CO"},
    {"name": "Comoros", "phone-code": "+269", "country-code": "KM"},
    {"name": "Cook Islands", "phone-code": "+682", "country-code": "CK"},
    {"name": "Costa Rica", "phone-code": "+506", "country-code": "CR"},
    {"name": "Croatia", "phone-code": "+385", "country-code": "HR"},
    {"name": "Cuba", "phone-code": "+53", "country-code": "CU"},
    {"name": "Curacao", "phone-code": "+599", "country-code": "CW"},
    {"name": "Cyprus", "phone-code": "+357", "country-code": "CY"},
    {"name": "Czech Republic", "phone-code": "+420", "country-code": "CZ"},
    {"name": "Democratic Republic of the Congo", "phone-code": "+243", "country-code": "CD"},
    {"name": "Denmark", "phone-code": "+45", "country-code": "DK"},
    {"name": "Djibouti", "phone-code": "+253", "country-code": "DJ"},
    {"name": "Dominica", "phone-code": "+1-767", "country-code": "DM"},
    {"name": "Dominican Republic", "phone-code": "+1-809", "country-code": "DO"},
    {"name": "Dominican Republic", "phone-code": "+1-829", "country-code": "DO"},
    {"name": "Dominican Republic", "phone-code": "+1-849", "country-code": "DO"},
    {"name": "East Timor", "phone-code": "+670", "country-code": "TL"},
    {"name": "Ecuador", "phone-code": "+593", "country-code": "EC"},
    {"name": "Egypt", "phone-code": "+20", "country-code": "EG"},
    {"name": "El Salvador", "phone-code": "+503", "country-code": "SV"},
    {"name": "Equatorial Guinea", "phone-code": "+240", "country-code": "GQ"},
    {"name": "Eritrea", "phone-code": "+291", "country-code": "ER"},
    {"name": "Estonia", "phone-code": "+372", "country-code": "EE"},
    {"name": "Ethiopia", "phone-code": "+251", "country-code": "ET"},
    {"name": "Falkland Islands", "phone-code": "+500", "country-code": "FK"},
    {"name": "Faroe Islands", "phone-code": "+298", "country-code": "FO"},
    {"name": "Fiji", "phone-code": "+679", "country-code": "FJ"},
    {"name": "Finland", "phone-code": "+358", "country-code": "FI"},
    {"name": "France", "phone-code": "+33", "country-code": "FR"},
    {"name": "French Polynesia", "phone-code": "+689", "country-code": "PF"},
    {"name": "Gabon", "phone-code": "+241", "country-code": "GA"},
    {"name": "Gambia", "phone-code": "+220", "country-code": "GM"},
    {"name": "Georgia", "phone-code": "+995", "country-code": "GE"},
    {"name": "Germany", "phone-code": "+49", "country-code": "DE"},
    {"name": "Ghana", "phone-code": "+233", "country-code": "GH"},
    {"name": "Gibraltar", "phone-code": "+350", "country-code": "GI"},
    {"name": "Greece", "phone-code": "+30", "country-code": "GR"},
    {"name": "Greenland", "phone-code": "+299", "country-code": "GL"},
    {"name": "Grenada", "phone-code": "+1-473", "country-code": "GD"},
    {"name": "Guam", "phone-code": "+1-671", "country-code": "GU"},
    {"name": "Guatemala", "phone-code": "+502", "country-code": "GT"},
    {"name": "Guernsey", "phone-code": "+44-1481", "country-code": "GG"},
    {"name": "Guinea", "phone-code": "+224", "country-code": "GN"},
    {"name": "Guinea-Bissau", "phone-code": "+245", "country-code": "GW"},
    {"name": "Guyana", "phone-code": "+592", "country-code": "GY"},
    {"name": "Haiti", "phone-code": "+509", "country-code": "HT"},
    {"name": "Honduras", "phone-code": "+504", "country-code": "HN"},
    {"name": "Hong Kong", "phone-code": "+852", "country-code": "HK"},
    {"name": "Hungary", "phone-code": "+36", "country-code": "HU"},
    {"name": "Iceland", "phone-code": "+354", "country-code": "IS"},
    {"name": "India", "phone-code": "+91", "country-code": "IN"},
    {"name": "Indonesia", "phone-code": "+62", "country-code": "ID"},
    {"name": "Iran", "phone-code": "+98", "country-code": "IR"},
    {"name": "Iraq", "phone-code": "+964", "country-code": "IQ"},
    {"name": "Ireland", "phone-code": "+353", "country-code": "IE"},
    {"name": "Isle of Man", "phone-code": "+44-1624", "country-code": "IM"},
    {"name": "Israel", "phone-code": "+972", "country-code": "IL"},
    {"name": "Italy", "phone-code": "+39", "country-code": "IT"},
    {"name": "Ivory Coast", "phone-code": "+225", "country-code": "CI"},
    {"name": "Jamaica", "phone-code": "+1-876", "country-code": "JM"},
    {"name": "Japan", "phone-code": "+81", "country-code": "JP"},
    {"name": "Jersey", "phone-code": "+44-1534", "country-code": "JE"},
    {"name": "Jordan", "phone-code": "+962", "country-code": "JO"},
    {"name": "Kazakhstan", "phone-code": "+7", "country-code": "KZ"},
    {"name": "Kenya", "phone-code": "+254", "country-code": "KE"},
    {"name": "Kiribati", "phone-code": "+686", "country-code": "KI"},
    {"name": "Kosovo", "phone-code": "+383", "country-code": "XK"},
    {"name": "Kuwait", "phone-code": "+965", "country-code": "KW"},
    {"name": "Kyrgyzstan", "phone-code": "+996", "country-code": "KG"},
    {"name": "Laos", "phone-code": "+856", "country-code": "LA"},
    {"name": "Latvia", "phone-code": "+371", "country-code": "LV"},
    {"name": "Lebanon", "phone-code": "+961", "country-code": "LB"},
    {"name": "Lesotho", "phone-code": "+266", "country-code": "LS"},
    {"name": "Liberia", "phone-code": "+231", "country-code": "LR"},
    {"name": "Libya", "phone-code": "+218", "country-code": "LY"},
    {"name": "Liechtenstein", "phone-code": "+423", "country-code": "LI"},
    {"name": "Lithuania", "phone-code": "+370", "country-code": "LT"},
    {"name": "Luxembourg", "phone-code": "+352", "country-code": "LU"},
    {"name": "Macau", "phone-code": "+853", "country-code": "MO"},
    {"name": "Macedonia", "phone-code": "+389", "country-code": "MK"},
    {"name": "Madagascar", "phone-code": "+261", "country-code": "MG"},
    {"name": "Malawi", "phone-code": "+265", "country-code": "MW"},
    {"name": "Malaysia", "phone-code": "+60", "country-code": "MY"},
    {"name": "Maldives", "phone-code": "+960", "country-code": "MV"},
    {"name": "Mali", "phone-code": "+223", "country-code": "ML"},
    {"name": "Malta", "phone-code": "+356", "country-code": "MT"},
    {"name": "Marshall Islands", "phone-code": "+692", "country-code": "MH"},
    {"name": "Mauritania", "phone-code": "+222", "country-code": "MR"},
    {"name": "Mauritius", "phone-code": "+230", "country-code": "MU"},
    {"name": "Mayotte", "phone-code": "+262", "country-code": "YT"},
    {"name": "Mexico", "phone-code": "+52", "country-code": "MX"},
    {"name": "Micronesia", "phone-code": "+691", "country-code": "FM"},
    {"name": "Moldova", "phone-code": "+373", "country-code": "MD"},
    {"name": "Monaco", "phone-code": "+377", "country-code": "MC"},
    {"name": "Mongolia", "phone-code": "+976", "country-code": "MN"},
    {"name": "Montenegro", "phone-code": "+382", "country-code": "ME"},
    {"name": "Montserrat", "phone-code": "+1-664", "country-code": "MS"},
    {"name": "Morocco", "phone-code": "+212", "country-code": "MA"},
    {"name": "Mozambique", "phone-code": "+258", "country-code": "MZ"},
    {"name": "Myanmar", "phone-code": "+95", "country-code": "MM"},
    {"name": "Namibia", "phone-code": "+264", "country-code": "NA"},
    {"name": "Nauru", "phone-code": "+674", "country-code": "NR"},
    {"name": "Nepal", "phone-code": "+977", "country-code": "NP"},
    {"name": "Netherlands", "phone-code": "+31", "country-code": "NL"},
    {"name": "Netherlands Antilles", "phone-code": "+599", "country-code": "AN"},
    {"name": "New Caledonia", "phone-code": "+687", "country-code": "NC"},
    {"name": "New Zealand", "phone-code": "+64", "country-code": "NZ"},
    {"name": "Nicaragua", "phone-code": "+81", "country-code": "NI"},
    {"name": "Niger", "phone-code": "+227", "country-code": "NE"},
    {"name": "Nigeria", "phone-code": "+234", "country-code": "NG"},
    {"name": "Niue", "phone-code": "+683", "country-code": "NU"},
    {"name": "Northern Mariana Islands", "phone-code": "+1-670", "country-code": "MP"},
    {"name": "North Korea", "phone-code": "+850", "country-code": "KP"},
    {"name": "Norway", "phone-code": "+47", "country-code": "NO"},
    {"name": "Oman", "phone-code": "+968", "country-code": "OM"},
    {"name": "Pakistan", "phone-code": "+92", "country-code": "PK"},
    {"name": "Palau", "phone-code": "+680", "country-code": "PW"},
    {"name": "Palestine", "phone-code": "+970", "country-code": "PS"},
    {"name": "Panama", "phone-code": "+507", "country-code": "PA"},
    {"name": "Papua New Guinea", "phone-code": "+675", "country-code": "PG"},
    {"name": "Paraguay", "phone-code": "+595", "country-code": "PY"},
    {"name": "Peru", "phone-code": "+51", "country-code": "PE"},
    {"name": "Philippines", "phone-code": "+63", "country-code": "PH"},
    {"name": "Pitcairn", "phone-code": "+64", "country-code": "PN"},
    {"name": "Poland", "phone-code": "+48", "country-code": "PL"},
    {"name": "Portugal", "phone-code": "+351", "country-code": "PT"},
    {"name": "Puerto Rico", "phone-code": "+1-787", "country-code": "PR"},
    {"name": "Puerto Rico", "phone-code": "+1-939", "country-code": "PR"},
    {"name": "Qatar", "phone-code": "+974", "country-code": "QA"},
    {"name": "Republic of the Congo", "phone-code": "+242", "country-code": "CG"},
    {"name": "Reunion", "phone-code": "+262", "country-code": "RE"},
    {"name": "Romania", "phone-code": "+40", "country-code": "RO"},
    {"name": "Russia", "phone-code": "+7", "country-code": "RU"},
    {"name": "Rwanda", "phone-code": "+250", "country-code": "RW"},
    {"name": "Saint Barthelemy", "phone-code": "+590", "country-code": "BL"},
    {"name": "Saint Helena", "phone-code": "+290", "country-code": "SH"},
    {"name": "Saint Kitts and Nevis", "phone-code": "+1-869", "country-code": "KN"},
    {"name": "Saint Lucia", "phone-code": "+1-758", "country-code": "LC"},
    {"name": "Saint Martin", "phone-code": "+590", "country-code": "MF"},
    {"name": "Saint Pierre and Miquelon", "phone-code": "+508", "country-code": "PM"},
    {"name": "Saint Vincent and the Grenadines", "phone-code": "+1-784", "country-code": "VC"},
    {"name": "Samoa", "phone-code": "+685", "country-code": "WS"},
    {"name": "San Marino", "phone-code": "+378", "country-code": "SM"},
    {"name": "Sao Tome and Principe", "phone-code": "+239", "country-code": "ST"},
    {"name": "Saudi Arabia", "phone-code": "+966", "country-code": "SA"},
    {"name": "Senegal", "phone-code": "+221", "country-code": "SN"},
    {"name": "Serbia", "phone-code": "+381", "country-code": "RS"},
    {"name": "Seychelles", "phone-code": "+248", "country-code": "SC"},
    {"name": "Sierra Leone", "phone-code": "+232", "country-code": "SL"},
    {"name": "Singapore", "phone-code": "+65", "country-code": "SG"},
    {"name": "Sint Maarten", "phone-code": "+1-721", "country-code": "SX"},
    {"name": "Slovakia", "phone-code": "+421", "country-code": "SK"},
    {"name": "Slovenia", "phone-code": "+386", "country-code": "SI"},
    {"name": "Solomon Islands", "phone-code": "+677", "country-code": "SB"},
    {"name": "Somalia", "phone-code": "+252", "country-code": "SO"},
    {"name": "South Africa", "phone-code": "+27", "country-code": "ZA"},
    {"name": "South Korea", "phone-code": "+82", "country-code": "KR"},
    {"name": "South Sudan", "phone-code": "+211", "country-code": "SS"},
    {"name": "Spain", "phone-code": "+34", "country-code": "ES"},
    {"name": "Sri Lanka", "phone-code": "+94", "country-code": "LK"},
    {"name": "Sudan", "phone-code": "+249", "country-code": "SD"},
    {"name": "Suriname", "phone-code": "+597", "country-code": "SR"},
    {"name": "Svalbard and Jan Mayen", "phone-code": "+47", "country-code": "SJ"},
    {"name": "Swaziland", "phone-code": "+268", "country-code": "SZ"},
    {"name": "Sweden", "phone-code": "+46", "country-code": "SE"},
    {"name": "Switzerland", "phone-code": "+41", "country-code": "CH"},
    {"name": "Syria", "phone-code": "+963", "country-code": "SY"},
    {"name": "Taiwan", "phone-code": "+886", "country-code": "TW"},
    {"name": "Tajikistan", "phone-code": "+992", "country-code": "TJ"},
    {"name": "Tanzania", "phone-code": "+255", "country-code": "TZ"},
    {"name": "Thailand", "phone-code": "+66", "country-code": "TH"},
    {"name": "Togo", "phone-code": "+228", "country-code": "TG"},
    {"name": "Tokelau", "phone-code": "+690", "country-code": "TK"},
    {"name": "Tonga", "phone-code": "+676", "country-code": "TO"},
    {"name": "Trinidad and Tobago", "phone-code": "+1-868", "country-code": "TT"},
    {"name": "Tunisia", "phone-code": "+216", "country-code": "TN"},
    {"name": "Turkey", "phone-code": "+90", "country-code": "TR"},
    {"name": "Turkmenistan", "phone-code": "+993", "country-code": "TM"},
    {"name": "Turks and Caicos Islands", "phone-code": "+1-649", "country-code": "TC"},
    {"name": "Tuvalu", "phone-code": "+688", "country-code": "TV"},
    {"name": "U.S. Virgin Islands", "phone-code": "+1340", "country-code": "VI"},
    {"name": "Uganda", "phone-code": "+256", "country-code": "UG"},
    {"name": "Ukraine", "phone-code": "+380", "country-code": "UA"},
    {"name": "United Arab Emirates", "phone-code": "+971", "country-code": "AE"},
    {"name": "United Kingdom", "phone-code": "+44", "country-code": "GB"},
    {"name": "United States", "phone-code": "+1", "country-code": "US"},
    {"name": "Uruguay", "phone-code": "+598", "country-code": "UY"},
    {"name": "Uzbekistan", "phone-code": "+998", "country-code": "UZ"},
    {"name": "Vanuatu", "phone-code": "+678", "country-code": "VU"},
    {"name": "Vatican", "phone-code": "+379", "country-code": "VA"},
    {"name": "Venezuela", "phone-code": "+58", "country-code": "VE"},
    {"name": "Vietnam", "phone-code": "+84", "country-code": "VN"},
    {"name": "Wallis and Futuna", "phone-code": "+681", "country-code": "WF"},
    {"name": "Western Sahara", "phone-code": "+212", "country-code": "EH"},
    {"name": "Yemen", "phone-code": "+967", "country-code": "YE"},
    {"name": "Zambia", "phone-code": "+260", "country-code": "ZM"},
    {"name": "Zimbabwe", "phone-code": "+263", "country-code": "ZW"}
];
static HEADER_HEIGHT_BEFORE_LOGIN = 125;
static HEADER_HEIGHT_AFTER_LOGIN = 105;

static PROMOTION_TYPE = {
  CASHBACK: 'CASHBACK',
  REBATE: 'REBATE',
  DEPOSIT: 'DEPOSIT',
  RELOAD: 'RELOAD',
  FREE: 'FREE',
  REWARD: 'REWARD'
}

static PROMOTION_VALIDATION = {
  VALIDATE_WELCOME_BONUS: 'VALIDATE_WELCOME_BONUS',
  VALIDATE_REACTIVATION_BONUS: 'VALIDATE_REACTIVATION_BONUS',
  VALIDATE_CASHBACK_REBATE_BONUS: 'VALIDATE_CASHBACK_REBATE_BONUS',
}

static PROMOTION_CLAIM = {
  CLAIM_WELCOME_BONUS: 'CLAIM_WELCOME_BONUS',
  CLAIM_REACTIVATION_BONUS: 'CLAIM_REACTIVATION_BONUS',
  CLAIM_CASHBACK_REBATE: 'CLAIM_CASHBACK_REBATE' 
}

static PLAYER_TYPE = {
  CASH: 'CASH',
  CREDIT: 'CREDIT'
}

static PRODUCT_TYPE = {
  IFORIUM: 'IFORIUM',
}
static MAX_LENGTH = {
  PASSWORD: 16,
  LOGIN_ID: 15,
  DEFAULT_FIRST_LAST_NAME_LENGTH: 35,
}

static REGISTER_ERROR = {
  REG_LOGIN_ID_POLICY: 'REG_LOGINID_POLICY',
  ERROR_REGISTER_LOGIN_EXISTED: 'ERROR_REGISER_LOGIN_EXISTED',
  REG_FULLNAME_INVALID: 'REG_FULLNAME_INVALID',
  PASSWORD_ALPHA_INVALID: 'Settings Page_._REG_PASSWORD_ALPHA_INVALID',
  PASSWORD_NUMBER_INVALID: 'Settings Page_._REG_PASSWORD_NUMBER_INVALID',
  ERROR_PASSWORD_CONFIRM_INCORRECT: 'ERROR_PASSWORD_CONFIRM_INCORRECT',
  INVALID_EMAIL: 'INVALID_EMAIL',
  REG_EMAIL_EXIST: 'REG_EMAIL_EXIST',
  INVALID_FORMAT_CONTACT_NUMBER: 'INVALID_FORMAT_CONTACT_NUMBER',
  NUMERIC_REQUIRED: 'Only numeric characters are allowed',
  INVALID_DATE: 'INVALID_DATE',
  ERROR_REGISTER_FAILED: 'ERROR_REGISTER_FAILED',
  INVALID_CAPTCHA: 'INVALID_CAPTCHA',
  INVALID_DOB: 'INVALID_DOB',
  ERROR_EMAIL_EXISTED: 'ERROR_EMAIL_EXISTED',
  ERROR_PASSWORD_POLICIES: 'ERROR_PASSWORD_POLICIES',
  ERROR_SERVICE: 'ERROR_SERVICE',
  MANDATORY: 'mandatory'
}  
static DEFAULT_CURRENCY_THAI = "THB";
static DEFAULT_CURRENCY_CHINA = "CNY";
static DEFAULT_COUNTRY_THAI = "TH";
static DEFAULT_COUNTRY_CHINA = "CN";
static COUNTRY_BY_IP  = [{"country-code":"MY","currency":"MYR"},{"country-code":"ID","currency":"IDR"},{"country-code": "TH","currency":"THB"},{"country-code":"VN","currency":"VND"}];
static INSTANT_MESSENGER = [
  {"name": "QQ", "value": "QQ"},
  {"name": "Skype", "value": "Skype"},
  {"name": "Line", "value": "Line"},
  {"name": "WeChat", "value": "WeChat"}];

static SECURITY_QUESTIONS = [
  {"value":"MOTHERS_FIRST_NAME", "name":"Mother's first name?"},
  {"value":"NAME_OF_FAVORITE_BOOK", "name":"Name of favorite book?"},
  {"value":"FAVORITE_PETS_NAME", "name":"Favorite pet's name?"},
  {"value":"FAVORITE_MOVIE", "name":"Favorite movie?"},
  {"value":"FAVORITE_HOBBY", "name":"Favorite hobby?"},
  {"value":"FAVORITE_SPORT_TEAM", "name":"Favorite sport team?"}];

  static TITLE = [
    {"name": "Mr", "value": "MR"},
    {"name": "Mrs", "value": "MRS"},
    {"name": "Ms", "value": "MS"}
  ];

  static CMS_LINK = {
    sportUrl: "/asian/sport",
    casinoUrl: "/asian/canino",
    aboutUs: "/static/index.php/{lang}",
    termsConditions: "/static/index.php/{lang}/information/termsconditions",
    responsibleGaming: "/static/index.php/{lang}/information/responsiblegaming",
    privacyPolicy: "/static/index.php/{lang}/information/privacypolicy",
    bettingRules: "/static/index.php/{lang}/help/bettingrules",
    teaserBettingRules: "/{lang}/help/bettingrules#Teasers-Rules",
    betsOffered: "/static/index.php/{lang}/help/betsoffered",
    FAQ: "/static/index.php/{lang}/help/faq",
    domainLicenseSeal: "pinnacle888.com",
    affiliates: "/affiliate/web/register",
    b2b: "http://www.pinnaclesolution.com/{lang}/",
    contactUs: "https://zh-cn.help.pinnacle888.com/{lang}/support/tickets/new",
    clearCache: "/esthardsk/resources/clear_cache.zip",
  }

  static NEW_CMS_LINK = {
    termsConditions: "/{lang}/cms/{skin}/information/termsconditions",
  }

  static MOBILE_DOMAIN = "ld176988.com"
  static systemidvar = "424"
  static MOBILE_PAYMENT_URL = "/payment/web/en/deposit/mb-pin-pay"
  static MOBILE_MYBET_URL ="/m/{lang}/asian/my-bets"

  static DATEFORMAT = {
    DATEPICKER: 'dd/mm/yyyy',
    COMMONFORMAT: 'DD/MM/YYYY'
  }

  static DATEPICKER_FIELD = {
    FROM_DATE: 'FROM_DATE',
    TO_DATE: 'TO_DATE'
  }

  static FORGOTOPTIONS = {
    ForgotPassword: 1,
    ForgotUsername: 2
  }
  static WALLET_CODE = {
    SB : 'SB',
    AGIN : 'AGIN',
    CR855 : 'CR855',
    IFORIUM : 'IFORIUM'
  } 

  static DEFAULT_OPTIONS_STATEMENT = [
    {
      key: 0,
      label: 'Current Month',
      value: '0'
    },
    {
      key : 1,
      label: 'Last Month',
      value: '1'
    }
  ]

  static RESTRICT15DAYS_OPTIONS_STATEMENT = [
    {
      key: 2,
      label: 'Last week',
      value: '2'
    },
    {
      key : 99,
      label: 'Custom',
      value: '99'
    }
  ]

  static CUSTOM_OPTIONS_STATEMENT = '99'

  static B2BTRANSACTION = {
    transactionType: 0,
    amount:2
  }

  static SIDE_BAR_NAME = {
    LEFT: 'LEFT_MENU',
    RIGHT: 'RIGHT_MENU',
    CLOSE: 'CLOSE'
  }

  static INFINITE_SCROLL = {
    EVENTS_EACH_PAGE: 3,
    OUTRIGHT_EVENTS_EACH_PAGE: 6,
    MAXIMUM_LEAGUE_INDEX_FOR_FIRST_RENDER: 2,
    OUTRIGHT_MAXIMUM_LEAGUE_INDEX_FOR_FIRST_RENDER: 4,
    DISTANCE_FROM_BOTTOM: 100
  }

  static JACKPOT_INTERVAL_TIME = 15;
  static SIDE_BAR_INTERVAL_TIME = 15;
  static CASINO_LABEL = {
    HOT: "HOT",
    NEW: "NEW",
    JACKPOT: "JACKPOT"
  }

  static actions = {
    SELECT_MAIN_CATEGORY: 'SELECT_MAIN_CATEGORY',
    SELECT_SUB_CATEGORY: 'SELECT_SUB_CATEGORY',
    SELECT_PROVIDER: 'SELECT_PROVIDER',
    SELECT_MORE_GAMES: 'SELECT_MORE_GAMES',
    SEARCH_NAME: 'SEARCH_NAME',
    OPEN_SEARCH_BAR: 'OPEN_SEARCH_BAR',
    CLOSE_SEARCH_BAR: 'CLOSE_SEARCH_BAR',
    OPEN_FAVOURITE_GAMES: 'OPEN_FAVOURITE_GAMES',
    OPEN_CATEGOGY_FAVOURITES: 'OPEN_CATEGOGY_FAVOURITES',
    SELECT_PROVIDER_FAVOURITES: 'SELECT_PROVIDER_FAVOURITES'
  };

  static WAGER_NUMBER_PER_PAGE = 10;

  static DEFAULT_LOCALE = 'en_US';
  static DEFAULT_TIME_ZONE = 'GMT-04:00';
  static DEFAULT_TIME_ZONE_ID = 'America/Curacao';
  static DEFAULT_FORMAT_DATE_TIME = 'YYYY-MM-DD HH:mm:ss'
static PROMOTION_CATEGORIES = [
  {
    promotionCategoryId: 3,
    promotionCategoryName: 'Sports',
    promotionCategoryDesc: 'Sports Book',
  },
  {
    promotionCategoryId: 4,
    promotionCategoryName: 'E Sports',
    promotionCategoryDesc: 'E-Sports',
  },
  {
    promotionCategoryId: 1,
    promotionCategoryName: 'Live Casino',
    promotionCategoryDesc: 'Live Casino',
  },
  {
    promotionCategoryId: 2,
    promotionCategoryName: 'Casino',
    promotionCategoryDesc: 'Games',
  },
  {
    promotionCategoryId: 5,
    promotionCategoryName: 'Virtual Sports',
    promotionCategoryDesc: 'Virtual Sports',
    code: 'VS'
  },
  {
    promotionCategoryId: 6,
    promotionCategoryName: 'Bet Builder',
    promotionCategoryDesc: 'Bet Builder',
    code: 'BB'
  },
]

static BET_ERROR_CODE = {
  INVALID_ODDS_FORMAT: "INVALID_ODDS_FORMAT",
  ROUND_ROBIN_DISALLOWED: "ROUND_ROBIN_DISALLOWED",
  ERROR3116: "ERROR3116",
  ERROR3103: "ERROR3103",
  ERROR3104: "ERROR3104",
  INVALID_ROUND_ROBIN_OPTIONS: "INVALID_ROUND_ROBIN_OPTIONS",
  MINIMUM_ROUND_ROBIN_OPTIONS: "MINIMUM_ROUND_ROBIN_OPTIONS",
  INVALID_LEGS: "INVALID_LEGS"
}

static BB_MESSAGE = {
  LOGIN_REQUIRED: 'ds::login',
  IFRAME_INFO : 'ds::widgets::height',
  DS_BETSLIP : 'ds::betslip',
  DS_PLACE : 'ds::betbuilder::placed',
  READY: 'ds::ready',
  LOADED: 'ds::loaded'
}

static BB_ERROR = {
  API_DISABLE: 'API_DISABLE'
}

static VERSION_NOT_SUPPORTED = {
  CHROME: 72,
  SAFARI: 14.5
}

static IFRAME_MESSAGES = {
  DP: "dp",
  IFRAME_LOADED: "isIframeLoaded",
  SELECTION_INFO: "selectionInfo",
  OPEN_CONTACT_US: 'contactUsTriggerNGC'
}

static LANG_BETTING_RULE_SUPPORT = [
  "en_US",
  "zh_CN",
  "zh_TW",
  "id_ID",
  "vi_VN",
  "ja_JP",
  "th_TH",
  "es_ES",
  "ko_KR",
  "ru_RU",
  "pt_BR",
  "fi_FI"
]

static ODDS_SELECTION_TYPE = {
  NORMAL: 'NORMAL',
  OUTRIGHT: 'OUTRIGHT'
}
  static DEFAULT_LOGO_DATES = {
    startDate: '2023-08-31T05:00:00Z',
    endDate: '2024-02-29T05:00:00Z'
  }

static LOGO_DATES_ANNIVERSARY_KEY = 'logoDates';

static PROMOTION_CATEGORY_IDS = {
    SB: 3,
    ESPORTS: 4,
    LIVE_CASINO: 1,
    CASINO: 2,
    VS: 5
};

static BETSLIP_TAB_CONFIG = [
  {
    id: "tab-single",
    value: "single",
    title: "Singles"
  },
  {
    id: "tab-parlay",
    value: "parlay",
    title: "Parlays"
  },
  {
    id: "tab-teaser",
    value: "teaser",
    title: "Teasers"
    }
  ];
  static LOCALE_PATH_MAPPING = {
    "nb_NO": "no"
  };
  static MFA_CONSTANTS = {
    SET_MFA_METHOD_TYPE_SUCCESS: 'SET_MFA_METHOD_TYPE_SUCCESS',
    SAVE_QR_OTP_SUCCESS: 'QR_OTP_SAVE_SUCCESS',
    SAVE_QR_OTP_ERROR: 'SAVE_QR_OTP_ERROR',
    EMAIL_OTP_EXPIRED: 'EMAIL_OTP_EXPIRED',
    QR_OTP_SAVE_FAILED: 'QR_OTP_SAVE_FAILED',
    EMAIL_AUTH: 'EMAIL1',
    APP_AUTH: 'TOTP_APP',
    OTP_SAVE_SUCCESS: 'OTP_SAVE_SUCCESS',
    EMAIL_OTP_INPUT_FAILED: 'EMAIL_OTP_INPUT_FAILED',
    EMAIL_OTP_INPUT_SUCCESS: 'EMAIL_OTP_INPUT_SUCCESS',
    RESEND_DELAY: 60,
    DATA_PREFIX_IMG: 'data:image/png;base64,'
  };

  static MFA_TRANSLATIONS = {
    OTP_CONFIRM: {
      title: "ENTER_YOUR_OTP",
      description: "CONFIRM_OTP_HEADER_DESCRIPTION",
      bodyAuthenMobileAppDescription: "CONFIRM_OTP_MOBILE_APP_DESCRIPTION",
      descriptionRequireInputOTP: "DESCRIPTION_REQUIRE_INPUT_OTP",
      textButton: "Submit",
      inputLabel: "ONE_TIME_PASSWORD",
    },
    AUTH_METHOD: {
      title: "Multi-Factor Authentication (MFA)",
      description: "MULTI_FACTOR_HEADER_DESCRIPTION",
      bodyAuthenMobileAppDescription: "CONFIRM_OTP_MOBILE_APP_DESCRIPTION",
      descriptionRequireInputOTP: "DESCRIPTION_REQUIRE_INPUT_OTP",
      textButton: "Update MFA",
      inputLabel: "Authentication code",
    },
  }

  static PAGE_NAME = {
    ODDS_PAGE_CONTAINER: "oddsPageContainer",
    HOME_PAGE_CONTAINER: "homePageContainer"
  }

  static DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss"
  static DATETIME_NO_SECONDS = "YYYY-MM-DD HH:mm"
  static DATE_FORMAT = 'Do MMM YYYY';
  static TIME_FORMAT = 'HH:mm:ss';
  
  static YYYY_MM_DD_FORMAT = "YYYY-MM-DD";

  static DP_CONTAINER = {
    "asiaView": ["oddsPageContainer"],
    "euroView": ["leaguesPageContainer", "liveGamesContainer", "homePageContainer", "oddsPageContainer"]
  }

  static ATTENTION_MESSAGE = {
    ATTENTION: "Attention",
    LINE_CHANGED: "The odds changed during submission. Please resubmit and confirm your bet."
  }
  static ATTENTION_TYPE = {
    ERROR: "ERROR",
    WARNING: "WARNING"
  }

  static FORGOT_ACCOUNT = 'forgot-account'

  static NEW_BETSLIP_HEIGHT_BREAKPOINT = 812

  static INNING_LIVE_POSITION_CENTER = [29];
  static TEAM_PROPS_PRIORITY_PERIODS  = {29: [8]}
  
  static TYPE_SESSION = {
    BONUS_SUBSCRIPTION: "BONUS_SUBSCRIPTION",
    BONUS: "BONUS",
    DEPOSIT: "DEPOSIT"
  }

  static DATE_FILTER = {
    THIRTY_DAY: {
      label: "30 days",
      value: "THIRTY_DAY"
    },
    TWO_MONTH: {
      label: "2 months",
      value: "TWO_MONTH"
    },
    THREE_MONTH: {
      label: "3 months",
      value: "THREE_MONTH"
    },
    DATE_RANGE: {
      label: "Date range",
      value: "DATE_RANGE"
    }
  }

  static BONUS_HEADER_KEY = {
    BONUS_NAME: "BONUS_NAME"
  }

  static NO_RECORD = {
    BONUS_SUBSCRIPTION: "You have no active Bonus Subscriptions in the chosen date range.",
    BONUS: "You have no active Bonuses in the chosen date range.",
    DEPOSIT: "You have no deposit made within the chosen date range."
  }

  static GENERATE_COLOR_CLASS = {
    ACTIVE: "status color-active",
    ROLLED_OVER: "status color-lost",
    COMPLETED: "status color-completed",
    LOST: "status color-lost",
    BLOCKED: "status color-blocked",
    FORFEITED: "status color-lost",
    EXPIRED: "status color-lost",
  }

  static BONUS_STATUS = {
    ACTIVE: "ACTIVE",
    ROLLED_OVER: "ROLLED_OVER",
    LOST: "LOST",
    BLOCKED: "BLOCKED",
    FORFEITED: "FORFEITED",
    EXPIRED: "EXPIRED",
    COMPLETED: "COMPLETED",
    ALL_STATUSES: "ALL_STATUSES",
    REJECTED: "REJECTED"
  }

  static TOTAL_ACCUMULATED = {
    LOSSES_ACCUMULATED: 'Losses Accumulated',
    TURNOVER_VOLUME_ACCUMULATED: 'Turnover/Volume Accumulated'
  }

  static LIVE_STREAM_ELEMENT_ID = {
    MINI_PLAYER: 'mini-player-LS',
    MAIN_PLAYER: 'mainPlayerLS',
    LANGUAGE_DROP_DOWN: 'languageDropDownLS',
    PREVIOUS_MATCHUP_URL: 'previousMatchupURL',
    LIVE_STREAM_DATA_WATCHING: 'liveStreamDataWatching',
    LIVE_STREAM_DATA: 'liveStreamData',
    LAST_URL_WATCHING: 'lastUrlWatching',
    LIVE_STREAM: "live-stream",
    LIVE_SCOREBOARD: "live-scoreboard",
  }
  static POINT_STICK_LIVE_TABS = {
    POINT_STICK_LIVE_TABS : 140,
    SCROLL_TOP_POSITION: 1,
  }
  static MAT_URL_SEARCH_PARAMS = {
    EVENTID: 'eventId',
    SPECIALID: 'specialId',
    LEAGUEID: 'leagueId',
}
  static MATCHUP_ACTIONS_CALLBACK = {
    LOGIN_TO_WATCH_LIVE_STREAM: 'LOGIN_TO_WATCH_LIVE_STREAM',
    SHOW_MINI_PLAYER: 'SHOW_MINI_PLAYER',
    BACK_TO_MAIN_STREAM: 'BACK_TO_MAIN_STREAM',
    CLOSE_MINI_PLAYER: 'CLOSE_MINI_PLAYER',
    MOBILE_CHANGE_LIVE_STREAM_LANGUAGE: 'MOBILE_CHANGE_LANGUAGE',
  }

  static REGEX_ADDRESS = /^[a-zA-Z0-9\s,. ]*$/;

  static DEFAULT_WITHDRAWAL_METHOD = "USDT TRC20";

  static WITHDRAWAL_RESPONSE_MESSAGE = {
    SUCCESS: "Your withdrawal request has been submitted. We will conduct a second verification before we proceed with the withdrawal. The rate will then be locked if applicable.",
    NOT_AVAILABLE: "Withdrawals are not currently available.",
    REG_ERROR: "REG_ERROR"
  }

  static WITHDRAWAL_VALIDATION_ERROR = {
    EMPTY_ADDRESS: "Address must be supplied",
    EMPTY_AMOUNT: "Amount must be supplied",
    EMPTY_REMARKS: "Remarks must be entered if Other is selected."
  }

  static SELF_EXCLUSION_OPTIONS = [
    {
      id: "c7",
      title: "Do not allow me to sign in for the next 7 days",
      value: 7
    },
    {
      id: "c30",
      title: "Do not allow me to sign in for the next 30 days",
      value: 30
    },
    {
      id: "c90",
      title: "Do not allow me to sign in for the next 90 days",
      value: 90
    }
  ]

  static POPUP_LIST = {
    NEW_BETSLIP_MOBILE: "NEW_BETSLIP_MOBILE",
    LIVE_PARLAYS: "LIVE_PARLAYS",
    LOGIN_2FA_ENABLE: "LOGIN_2FA_ENABLE",
    SESSION_EXPIRED: "SESSION_EXPIRED",
  }

  static LEAGUE_PAGE_ROUTE = {
    SPORT: '/m/:lang/asian/sports/:sportName/:leagueName/:leagueId',
    ESPORT: '/m/:lang/asian/esports/:gameName/:leagueName/:leagueId'
  }

  static REGULAR_UNIT = 'regular'
  static ALL_PROVIDER_ID = '-2'

  static CASINO_PAGE = {
    SEARCH_DELAY: 1000,
    FILTER_PARAMS: {
      BEGIN_INDEX: "beginIndex",
      GAME_NAME: "gameName",
      CATEGORY_ID: "categoryId",
      PROVIDER: "provider",
    }
  }

  static DEFAULT_SPORT_OPTION_SUSPEND = {
    sportId: 29,
    market: 1,
    betTypeGroup: 1,
    period: 0,
    leagueIds: [],
    eSports: {},
    mode: 0,
    sportName: "soccer"
  }
  static CHANGE_PASSWORD_MESSAGES = {
    ENTER_NEW_PASSWORD: 'Please enter new password',
    CONFIRM_PASSWORD: 'Please confirm password',
    ENTER_CURRENT_PASSWORD: 'Please enter your current password',
    ENTER_SECURITY_QUESTION: 'Please enter security question',
    ENTER_SECURITY_ANSWER: 'Please enter security answer',
    WRONG_PASSWORD: 'Wrong current password!',
    CHANGE_PASSWORD_OK: 'Password Changed Successfully!',
    CHANGE_VIP_PASSWORD_OK: 'Password has been successfully reset.',
    OLD_NEW_PASS_NOT_SAME: 'Old and new password cannot be the same',
    NOT_REUSE_CURRENT_PASSWORD: 'Please do not reuse your current password',
    CONFIRM_PASSWORD_NOT_MATCH: 'CONFIRM_PASSWORD_NOT_MATCH',
    ERROR_PASSWORD_CONFIRM_INCORRECT: 'ERROR_PASSWORD_CONFIRM_INCORRECT',
    INVALID_INFO: "ERROR_FORGOTPASSWORD",
    REG_ERROR: "REG_ERROR",
    RESET_EXPIRE:"This password reset link has expired or is invalid. Please request a new password reset.",
    RESET_ALREADY_USED:"This password reset link has already been used. Please request a new password reset.",
    PASSWORD_RESET_SUCCESSFULLY:"Password has been reset. Please check your email for your new password.",
    EMAIL_SEND:"Email has been sent!",
  }

  static CHANGE_PASSWORD_STATUS = {
    SUCCESS: 1,
    EXPIRED_LINK: -1,
    INVALID_LINK: -2,
    ALREADY_USED_LINK: -3,
  }

  static ALL_GAMES_TITLE = {
    CASINO: 'all casino games',
    LIVE_CASINO: 'all live casino games',
    CHESS_AND_CARDS: 'all chess and cards',
  }

  static ESPORTS_LOGO_URL = '/estharmb/images/esports/'

  static MESSAGE_CONTENT_TYPE = {
    IFRAME_READY: 'IFRAME_READY',
    TNC_VERSION: 'TNC_VERSION',
    GET_TNC_VERSION: 'GET_TNC_VERSION',
  }
  
  static WAGER_RESULT = {
    WIN: "WIN",
    LOSE: "LOSE",
    DRAW: "DRAW",
    WIN_HALF: "WIN_HALF",
    LOSE_HALF: "LOSE_HALF",
    REFUNDED: "REFUNDED",
    BETTING: "BETTING",
    SETTLED: "SETTLED",
    OPEN: "OPEN"
  }

  static SERVER_TIME_ZONE_ID = 'America/New_York';

  static LOGIN_2FA = {
    MODE: {
      LOGIN: "LOGIN",
      CHANGE_SETTING: "CHANGE_SETTING",
      RESEND_EMAIL: "RESEND_EMAIL",
    },
    STATUS: {
      OTP_REQUIRED: "OTP_REQUIRED",
      EMAIL_OTP_INPUT_SUCCESS: "EMAIL_OTP_INPUT_SUCCESS",
      EMAIL_OTP_INPUT_FAILED: "EMAIL_OTP_INPUT_FAILED",
    },
    ACTION_TYPE: {
      LOGIN_2FA_USER_VERIFIED_OTP_REQUIRE: "LOGIN_2FA_USER_VERIFIED_OTP_REQUIRE",
      LOGIN_2FA_CHANGE_SETTING_OTP_REQUIRE: "LOGIN_2FA_CHANGE_SETTING_OTP_REQUIRE",
    },
    TRANSLATIONS: {
      TITLE_SETTING_LOGIN_OTP_CONFIRM: "TITLE_SETTING_LOGIN_OTP_CONFIRM",
      BODY_SETTING_LOGIN_OTP_CONFIRM: "BODY_SETTING_LOGIN_OTP_CONFIRM",
      SUBMIT_ENABLE_2FA_LOGIN: "SUBMIT_ENABLE_2FA_LOGIN",
      NOT_NOW: "NOT_NOW",
    },
    USER_SETTING: {
      TOGGLE_BUTTON_ID: "2faAtLogin",
    },
  }
  
  static MAINTENANCE_DATE_FORMAT = {
    zh_CN: "YYYY年MM月DD日 dddd",
    zh_TW: "YYYY年MM月DD日, dddd",
    ko_KR: "YYYY년 MM월 DD일, dddd",
    DEFAULT: "D MMMM YYYY, dddd",
  }
  
  
  static DEFAULT_FILE_CONFIG = {
    ALLOWED_FILES: "jpg, jpeg, png",
    MAX_FILE_SIZE: 8
  }
  
  static KYC_PURPOSE_STATUS = {
    VERIFIED: {
      label: 'Verified',
      value: 'VERIFIED',
      classNames: 'verified'
    },
    DECLINED: {
      label: 'Fail verification',
      value: 'DECLINED',
      classNames: 'failed'
    },
    PENDING: {
      label: 'Pending review',
      value: 'PENDING',
      classNames: 'pending'
    },
    WAITING_TRANSLATION: {
      label: 'Pending review',
      value: 'WAITING_TRANSLATION',
      classNames: 'pending'
    },
  }
  
  static LABEL_TYPE = {
    POI: {
      type: 'POI',
      label: 'Identification',
      kycType: 'CUSTOMER_VERIFIED',
    },
    POA: {
      type: 'POA',
      label: 'Address',
      kycType: 'ADDRESS_VERIFIED',
    },
    SELFIE: {
      type: 'SELFIE',
      label: 'Selfie',
      kycType: 'SELFIE_VERIFIED',
    },
  }
  
  static KYC_REQUEST_STATUS = {
    PENDING_UPLOAD: 'PENDING_UPLOAD',
    PENDING_REVIEW: 'PENDING_REVIEW',
    UNDER_MANUAL_REVIEW: 'UNDER_MANUAL_REVIEW',
    COMPLETED: 'COMPLETED',
  }
  
  static PRIORITY_PURPOSE_STATUS = {
    DEFAULT: 0,
    DECLINED: 1,
    PENDING: 2,
    VERIFIED: 3,
  }
  
  static BYTES_PER_MB = 1024 * 1024;
  static CASINO_IMAGE_PATH = '/member-casino-service/casino/casino-image';
  static IMAGE_LANDING_PAGE_PATH = `${process.env.PUBLIC_URL}/estharmb/images/pa/landing/`;
  static VERIFICATION_PATH = {
    DESKTOP: '{currentLanguage}/compact/account/verification',
    MOBILE: 'm/{currentLanguage}/asian/kyc/verification',
  }
}


// WEBPACK FOOTER //
// ./src/app/common/Constants.js